import React from 'react';
import CardSection from '../../Shared/CardSection';

const SuppContractValuesSection = ({ model, portalSettings }) => {

    const {
        box1Label,
        box2Label,
        box3Label,
        box1Value,
        box2Value,
        box3Value,
        paymentDay,
        certainPeriod,
        beginDate,
        nextDueDate,
        endDate,
    } = model.suppContractValues;

    const {
        productName,
        productType,
        issAge
    } = model.policyInfo;

    return (
        <div className="container container-section custom-width" id="values-container">
            {/* Top Row: Summary Cards */}
            <div className="flex-row">
                {[
                    { label: box1Label, value: box1Value },
                    { label: box2Label, value: box2Value },
                    { label: box3Label, value: box3Value }
                ]
                    .filter(({ value }) => value !== null && value !== "")
                    .map(({ label, value }, idx) => (
                        <div key={idx} className="policy-card small-card">
                            <div className="card">
                                <div className="card-body">
                                    <h6>{label}</h6>
                                    <h3 className="bold value">{value}</h3>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>

            {/* Second Row: Card Sections */}
            <div className="flex-row">
                {/* Contract Details */}
                <CardSection
                    title="Contract Details"
                    blocks={[
                        { label: "Product:", value: productName },
                        { label: "Product Type:", value: productType },
                        { label: "Issue Age:", value: issAge },
                        { label: "Payment Day:", value: paymentDay },
                        { label: "Certain Period:", value: certainPeriod },
                        { label: "Begin Date:", value: beginDate },
                        { label: "Next Due Date:", value: nextDueDate },
                        { label: "Termination Date:", value: endDate },
                    ]}
                />
            </div>
        </div>
    );
};

export default SuppContractValuesSection;